export { EditorModule } from './editor.module';
